/**
 * Created by rowthan on 2017/12/9. TODO show size
 * 包含核心 api 获取id,获取元素，不含UI
 */
export const getElementBySelector = function (queryString) {
  queryString = queryString.wid || queryString
  return document.getElementById(queryString) || document.getElementsByName(queryString)[0] || document.querySelector(queryString)
}
export const getElementSelector = function (element, parent) {
  element = element || this.lastClick
  if (!(element instanceof HTMLElement)) {
    console.error('input is not a HTML element')
    return {}
  }
  const result = {
    wid: '',
    type: '',
    top: 0,
    left: 0,
    viewLeft: element.getBoundingClientRect().left,
    viewTop: element.getBoundingClientRect().top,
    text: element.innerText
  }

  // construct data info of the element

  const id = element.id

  const name = element.name

  const tag = element.tagName.toLowerCase()

  const type = element.type ? element.type.toLowerCase() : ''

  let className = ''
  const classList = element.classList || []
  classList.forEach(function (item) {
    className += '.' + item
  })
  if (tag === 'body' || tag === 'html') {
    result.wid = tag
    result.type = tag
  }
  // location by id
  if (id && document.getElementById(id) === element) {
    const regExp = new RegExp('^[a-zA-Z]+')
    /** 当不为parent定位，且设置为简单结果时，直接返回id 否则使用完整路径标识符。注：两个if顺序不能更换，递归调用时 simpleId为undefined */
    if (!parent && this && this.options.simpleId) {
      result.wid = id
    } else if (regExp.test(id)) { /* 如果为parent定位，或者设置为完整结果时候，返回tag#id */
      result.wid = tag + '#' + id
    }
    result.type = 'document.getElementById()'
  }
  // location by name
  if (!result.wid && name && document.getElementsByName(name)[0] === element) {
    result.wid = name
    result.type = 'document.getElementsByName()'
  }
  // location by class
  if (!result.wid && className && document.querySelector(tag + className) === element) {
    result.wid = tag + className
    result.type = 'document.querySelector()'
    const classLength = classList.length
    if (classLength > 2) {
      let n = 1

      /** 使用class查询的个数，如2，4，8：使用2，4，8个className做查询 */

      const queryCount = []
      while (Math.pow(2, n) < classLength) {
        queryCount.push(Math.pow(2, n))
        n++
      }
      queryCount.push(classLength)

      for (let k = 0; k < queryCount.length; k++) {
        /** 使用class个数去查询 */
        // eslint-disable-next-line no-unused-vars
        const countNum = queryCount[k]
        // TODO 性能优化
      }
    }
  }
  // for radio
  const value = element.value
  let queryString = tag + "[value='" + value + "']"
  if (type === 'radio') {
    if (name) {
      queryString += "[name='" + name + "']"
    }
    if (document.querySelector(queryString) === element) {
      result.wid = queryString
      result.type = 'document.querySelector()'
    }
  }
  // location by mixed,order
  if (!result.wid) {
    queryString = tag
    queryString = className ? queryString + className : queryString
    queryString = name ? queryString + "[name='" + name + "']" : queryString
    if (getElementBySelector(queryString) === element) {
      result.wid = queryString
      result.type = 'document.querySelector()'
    }
  }
  // location by order
  if (!result.wid) {
    queryString = tag
    queryString = className ? queryString + className : queryString

    const elements = document.querySelectorAll(queryString)
    if (elements && elements.length > 0) {
      let index = null
      for (let i = 0; i < elements.length; i++) {
        if (element === elements[i]) {
          index = i + 1
          break
        }
      }
      if (index) {
        queryString = queryString + ':nth-child(' + index + ')'
        if (document.querySelector(queryString) === element) {
          result.wid = queryString
          result.type = 'document.querySelector()'
        }
      }
    }
  }
  // location by parent
  if (!result.wid) {
    if (!element.parentNode) {
      return
    }
    const parentQueryResult = getElementSelector(element.parentNode, true)

    const parentQueryString = parentQueryResult ? parentQueryResult.wid : ''
    if (!parentQueryString) {
      return {
        wid: '',
        type: 'NO_LOCATION'
      }
    }
    let targetQuery = tag
    if (className) {
      targetQuery += className
    }
    queryString = parentQueryString + '>' + targetQuery
    const queryElements = document.querySelectorAll(queryString)
    if (queryElements.length > 1) {
      queryString = null
      let index = null
      for (let j = 0; j < element.parentNode.children.length; j++) {
        if (element.parentNode.children[j] === element) {
          index = j + 1
          break
        }
      }
      if (index >= 1) {
        queryString = parentQueryString + '>' + targetQuery + ':nth-child(' + index + ')'
        const queryTarget = document.querySelector(queryString)
        if (queryTarget !== element) {
          queryString = null
        }
      }
    }
    result.wid = queryString
    result.type = 'document.querySelector()'
  }
  return result
}
